import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Bell } from 'lucide-react';
import NotificationFirebaseService from './NotificationFirebaseService';
import './NotificationBell.css';

const NotificationBell = ({ userId }) => {
  const navigate = useNavigate();
  const [unreadCount, setUnreadCount] = useState(0);

  useEffect(() => {
    if (!userId) {
      setUnreadCount(0);
      return;
    }

    // ✅ Listener Firebase en temps réel - Plus de polling !
    // Les notifications arrivent instantanément sans requêtes HTTP répétitives
    const unsubscribe = NotificationFirebaseService.subscribeToUnreadCount(
      userId,
      (count) => {
        setUnreadCount(count);
      }
    );

    // Nettoyage : se désabonner du listener quand le composant est démonté
    return () => {
      unsubscribe();
    };
  }, [userId]);

  const handleClick = () => {
    navigate('/notifications/history');
  };

  return (
    <div className="notification-bell-container">
      <button 
        onClick={handleClick}
        className="notification-bell-button"
        aria-label="Notifications"
        title="Voir les notifications"
      >
        <Bell size={20} />
        {unreadCount > 0 && (
          <span className="notification-badge">
            {unreadCount > 9 ? '9+' : unreadCount}
          </span>
        )}
      </button>
    </div>
  );
};

export default NotificationBell;
